const device = {
    path: '/device',
    name: 'deviceManagement',
    icon: 'icon2-2-2shouquanpeizhi',
    redirect: '/device/sensor',
    component: () => import('@/pages/layout/appMain'),
    children: [
        //传感器
        {
            icon: 'el-icon-s-cooperation',
            name: 'Sensor',
            path: '/sensor',
            component: () => import('@/pages/equipment/sensor/index.vue')
        },
        //网关路由
        {
            icon: 'el-icon-s-order',
            name: 'Gateway',
            path: '/gateway',
            component: () => import('@/pages/equipment/gateway/index.vue')
        },
        //显示屏
        {
            icon: 'el-icon-video-camera',
            name: 'Display',
            path: '/displayscreen',
            component: () => import('@/pages/equipment/displayscreen/index.vue')
        },
        // 中继
        {
            icon: 'el-icon-video-camera',
            name: 'Relay',
            path: '/relay',
            component: () => import('@/pages/equipment/relay/Relay.vue')
        },
        // 智能底座
        {
            icon: 'iconfont icon-dianjidizuo',
            name: 'Base',
            path: '/base',
            component: () => import('@/pages/equipment/base/Index.vue')
        },
        //气体
        {
            icon: 'iconfont icon-qiti',
            name: 'Gas',
            path: '/gas',
            component: () => import('@/pages/equipment/gas/index.vue')
        },
        //门磁
        {
            icon: 'iconfont icon-menci',
            name: 'Magnetism',
            path: '/magnetism',
            component: () => import('@/pages/equipment/magnetism/index.vue')
        },
    ]
};

export default device;
